import { ContentBase } from '../models';
import { ComponentContent } from '../models/component.model';

export const createElementId = (id: string) => `c-${id}`;

export const navigationIgnoreVariants: ComponentContent['variant'][] = ['grid', 'alert', 'banner'];

export const sortByPriorityThenAddedDate = (
    a: ContentBase,
    b: ContentBase,
    priorityList: string[]
) => {
    const priorityIndexA = priorityList.indexOf(a.id);
    const priorityIndexB = priorityList.indexOf(b.id);

    if (priorityIndexA !== -1 && priorityIndexB === -1) {
        return -1;
    }

    if (priorityIndexA === -1 && priorityIndexB !== -1) {
        return 1;
    }

    if (priorityIndexA !== -1 && priorityIndexB !== -1) {
        return priorityIndexA < priorityIndexB ? -1 : 1;
    }

    return a.added < b.added ? -1 : 1;
};
